import { Typography } from '@mui/material';
import { ImageSearchOutlined } from '@mui/icons-material';
import { BrandKey, brandTitleByKey } from '@prismamedia/one-brandkey';
import { ImageLoader, OneMedia } from '@prismamedia/one-components';
import { EditableMedia } from 'components/EditableMedia';
import { EditorState } from 'draft-js';
import React, { FC } from 'react';
import { BlockItemFormat } from '../';
import { BlockItemType, isOneMedia } from '../../../utils';
import { useStyles } from './styles';

interface BlockItemMediaProps {
  articleProps: Pick<
    BlockItemType,
    'brandKey' | 'media' | 'mediaForDisplay' | 'body' | 'blockType'
  >;
  format: BlockItemFormat;
  onEditField?: (field: string, value: string | OneMedia | EditorState) => void;
}

export const BlockItemMedia: FC<BlockItemMediaProps> = ({
  articleProps: { brandKey, media, mediaForDisplay, body, blockType },
  format: blockItemFormat,
  onEditField,
}) => {
  const classes = useStyles({ blockItemFormat });

  if (blockItemFormat !== BlockItemFormat.CONDENSED) {
    return (
      <EditableMedia
        blockType={blockType}
        slideShowBody={body}
        media={isOneMedia(media) ? media : null}
        mediaClassName={classes.media}
        fallbackClassName={classes.imageFallback}
        onMediaChange={(field: string, selectedMedia: OneMedia[]) =>
          onEditField?.(field, selectedMedia[0])
        }
      />
    );
  }

  return (
    <>
      <Typography className={classes.brandkey}>
        {brandTitleByKey[brandKey as BrandKey]}
      </Typography>

      <ImageLoader
        className={classes.media}
        image={<ImageSearchOutlined className={classes.imageFallback} />}
        src={mediaForDisplay}
      />
    </>
  );
};
